export default {
  employer_documents: [],
  end_documents: [],
  setZeroFields: false,
};
